/* eslint-disable max-classes-per-file */
// Disabled because these classes depend on each other and if they were in different files they'd cause circular
// dependencies.
import { __decorate, __metadata } from "tslib";
import { Type } from '@ftr/serialization';
import { TrmConversionStatus, TrmReconversionStatus, } from '../../type/recording';
import { Timecode } from '../../type/shared';
/**
 * Holds details on the result of a TRM conversion, whether it succeeded or failed and details on the success/failure
 */
export class TrmConversionResult {
    isSuccess() {
        return this instanceof TrmConversionSuccessResult;
    }
    isFailure() {
        return this instanceof TrmConversionFailureResult;
    }
    trmConversionStatus() {
        return this.isSuccess() ? TrmConversionStatus.Complete : TrmConversionStatus.Failed;
    }
    trmReconversionStatus() {
        return this.isSuccess() ? TrmReconversionStatus.Complete : TrmReconversionStatus.Failed;
    }
}
/**
 * Holds details of a successful TRM conversion
 */
export class TrmConversionSuccessResult extends TrmConversionResult {
    /**
     * @param outputs Details on the outputs produced by this TRM's conversion
     * @param timecode The timecode of the converted audio file
     */
    constructor(outputs, timecode) {
        super();
        this.outputs = outputs;
        this.timecode = timecode;
    }
}
__decorate([
    Type(() => Timecode),
    __metadata("design:type", Timecode
    /**
     * @param outputs Details on the outputs produced by this TRM's conversion
     * @param timecode The timecode of the converted audio file
     */
    )
], TrmConversionSuccessResult.prototype, "timecode", void 0);
/**
 * Holds details of a failed TRM conversion
 */
export class TrmConversionFailureResult extends TrmConversionResult {
    /**
     * @param reason Why the trm could not be converted
     */
    constructor(reason) {
        super();
        this.reason = reason;
    }
}
